import { render } from "./TermsPrivacy.vue?vue&type=template&id=0e2c1e18"
import script from "./TermsPrivacy.vue?vue&type=script&lang=js"
export * from "./TermsPrivacy.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__